import React, { useEffect, useState } from "react";
import "./index.scss";
import { useLocation, useNavigate } from "react-router-dom";
import PaymentOptions from "./PaymentOptions";
import { envConfig } from "../../constants";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { addressElementOptions } from "./helper";
import PaymentProvider from "./PaymentProvider";
import { useToast } from "../../context/ToastContext";
import { useTranslationContext } from "../../context/TranslationContext";

export const stripePromise = loadStripe(envConfig.REACT_APP_STRIPE_PUBLIC_KEY);

const Payment = () => {
  const navigate = useNavigate()
  const {showToast} = useToast()
  const {labelsIot} = useTranslationContext()
  const { state } = useLocation();
  const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
      if(!state?.sessionClientSecret || !state?.orderID) {
        navigate("/");
        if(!state?.sessionClientSecret){
        showToast('success', labelsIot?.LBLI0205 || "Payment successful! The invoice was paid using your available Stripe credit. It will be updated shortly.")
        }
      }
    }, [navigate,showToast, state?.orderID,labelsIot?.LBLI0205, state?.sessionClientSecret])

    return (
      <PaymentProvider isLoading={isLoading} >
        <Elements
        stripe={stripePromise}
        options={{
          clientSecret: state?.sessionClientSecret,
          ...addressElementOptions,
          locale: localStorage.getItem("i18nextLng"),
        }}
      >
     <PaymentOptions
          price={state?.price}
          returnUrl={`/payment-success?orderid=${state?.orderID}&random_id=${state?.randomId}&priceCurrency=${state?.priceCurrency}`}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
        />
      </Elements>
      {/* <PaymentSuccess/> */}
      </PaymentProvider>
    );
};

export default Payment;